import actionTypes from 'SRC/modules/redux/actionTypes'

export const setLoading = (isLoading) => ({
  type: actionTypes.SET_ADS_LOADING,
  payload: isLoading
})
